/************************************
MODULE:         Social feed
WHAT IT DOES:   Gets all the parametrs from DOM and initializes social feed
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    function init() {
        var socialfeed = $('.js-socialfeed');
        if (!socialfeed.length)
            return;
            require.ensure([], function () {
        var genericsocialfeed = require('generic.socialfeed');

        for (var i = 0, l = socialfeed.length; i < l; i++) {
            var socialfeedSingle = socialfeed.eq(i),
                settings = {},
                dataAttributes = socialfeedSingle.data();

            for (var attr in dataAttributes) {
                settings[attr] = dataAttributes[attr];
            }

            new genericsocialfeed(socialfeedSingle, settings);
        }

    }, 'genericFeed');
    }

    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.socialfeed.js
 ** module id = 60
 ** module chunks = 24
 **/